export const GOAL_CATS = [["unternehmen", "Unternehmensziele"], ["qualitaet", "Qualitätsziele"]];

export const blankGoal = (category) => ({ category, label: "", target: "", actual: "", unit: "%", direction: "min", note: "" });

export const fmtGoal = (v, unit) => {
  if (v == null || v === "") return "—";
  const n = Number(v).toLocaleString("de-DE", { maximumFractionDigits: 2 });
  return unit === "%" ? `${n} %` : n;
};

export const STATUS_STYLE = {
  erreicht: "text-emerald-700 bg-emerald-50",
  "nicht erreicht": "text-red-600 bg-red-50",
  "keine Daten": "text-slate-500 bg-slate-100",
  "kein Ziel": "text-slate-400 bg-slate-100",
};
export const QUAL_STYLE = { erreicht: "text-emerald-700 bg-emerald-50", teilweise: "text-amber-700 bg-amber-50", offen: "text-slate-600 bg-slate-100" };
